var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsf-area-cascader-panel" },
    [
      _c("el-autocomplete", {
        staticClass: "inline-input",
        attrs: {
          "popper-append-to-body": false,
          "fetch-suggestions": _vm.querySearch,
          placeholder: "请输入关键词",
          "suffix-icon": "el-icon-search",
        },
        on: {
          focus: _vm.handleFocus,
          blur: _vm.handleBlur,
          select: _vm.handleSelect,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var item = ref.item
              return [
                _vm._v(
                  " " + _vm._s(item[_vm.optionsTextField] || item.name) + " "
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.keyword,
          callback: function ($$v) {
            _vm.keyword = $$v
          },
          expression: "keyword",
        },
      }),
      _c("el-cascader-panel", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.firstLoading,
            expression: "firstLoading",
          },
        ],
        ref: "panel",
        attrs: { props: _vm.props },
        on: { change: _vm.handleChange },
        model: {
          value: _vm.value,
          callback: function ($$v) {
            _vm.value = $$v
          },
          expression: "value",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }